export default "__VITE_ASSET__BLW6iLHU__"